// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Brain-module__wrapper___zvgiu{display:grid}.Brain-module__tabs___hvwoq{padding:10px 0px;width:max(300px, min(100%, 380px));margin:0 auto}", "",{"version":3,"sources":["webpack://./src/pages/robot/Brain/Brain.module.scss"],"names":[],"mappings":"AAAA,+BACE,YAAA,CAIF,4BACE,gBAAA,CACA,kCAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "Brain-module__wrapper___zvgiu",
	"tabs": "Brain-module__tabs___hvwoq"
};
export default ___CSS_LOADER_EXPORT___;
